module.exports = __webpack_public_path__ + "media/honey-icons/icon-plug-eu-6b5c083d.svg";